var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { Cross2Icon, InfoCircledIcon } from "@radix-ui/react-icons";
import "./orderIntentNavbar.css";
import { useAuth, useCart, useOrderIntent, useServiceTypes, useUI } from "../../providers";
import { RadixToggleGroup } from "../primitives/RadixToggleGroup";
import { RadixButton } from "../primitives/RadixButton";
import { OrderTimeSelectionFlyOut } from "../orderTimeSelectionFlyOut";
import { OrderAddressDetailsFlyOut } from "../orderAddressDetailsFlyOut";
import { ChevronRightIcon, ClockIcon, DeliveryServiceIcon, GenericServiceIcon, PickupServiceIcon } from "../icons";
var getSessionStore = function () {
    var _a;
    var sessionStore = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store;
    if (!sessionStore || typeof sessionStore !== "object") {
        return null;
    }
    return sessionStore;
};
var getSessionStoreStatus = function () {
    var _a;
    var storeStatus = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store_status;
    if (!storeStatus || typeof storeStatus !== "object") {
        return null;
    }
    var candidate = storeStatus;
    var message = typeof candidate.message === "string" ? candidate.message.trim() : "";
    if ((typeof candidate.id !== "number" && typeof candidate.id !== "string") || !message) {
        return null;
    }
    return {
        id: candidate.id,
        message: message,
        expires_at: typeof candidate.expires_at === "string" ? candidate.expires_at : "",
    };
};
var getStoreAddressLines = function (store) {
    if (!store) {
        return { name: "", lineOne: "", lineTwo: "" };
    }
    var name = String(store.name || "").trim();
    var lineOne = String(store.address || "").trim();
    var lineTwo = [store.city, store.state, store.zip]
        .filter(function (segment) { return Boolean(String(segment || "").trim()); })
        .join(", ");
    return { name: name, lineOne: lineOne, lineTwo: lineTwo };
};
var getServiceTypeIcon = function (serviceTypeName) {
    var normalized = serviceTypeName.toLowerCase();
    if (normalized.includes("delivery")) {
        return React.createElement(DeliveryServiceIcon, null);
    }
    if (normalized.includes("pickup") || normalized.includes("carryout") || normalized.includes("takeout")) {
        return React.createElement(PickupServiceIcon, null);
    }
    return React.createElement(GenericServiceIcon, null);
};
var isDeliveryServiceType = function (serviceType) {
    if (!serviceType) {
        return false;
    }
    if (serviceType.has_delivery !== undefined && serviceType.has_delivery !== null) {
        return Boolean(Number(serviceType.has_delivery));
    }
    return Number(serviceType.pos_id) === 1;
};
var getAsapTimingLabel = function (currentTime) {
    var normalizedCurrentTime = String(currentTime || "").trim();
    if (!normalizedCurrentTime) {
        return "ASAP";
    }
    return "ASAP \u2022 ".concat(normalizedCurrentTime, " min");
};
var normalizeUrlForOrderIntent = function (rawUrl) {
    var hashIndex = rawUrl.indexOf("#");
    var withoutHash = hashIndex >= 0 ? rawUrl.slice(0, hashIndex) : rawUrl;
    var resolved = new URL(withoutHash || "/", window.location.origin);
    resolved.pathname = resolved.pathname.toLowerCase();
    resolved.search = "";
    resolved.hash = "";
    var normalized = resolved.href;
    while (normalized.length > 1 && normalized.endsWith("/")) {
        normalized = normalized.slice(0, -1);
    }
    return normalized;
};
var isOrderIntentNavbarRoute = function () {
    var currentHref = normalizeUrlForOrderIntent(window.location.href || "/");
    var baseRelativeUri = String(window.relativeURI() || "/");
    var menuRelativeUri = baseRelativeUri.endsWith("/") ? "".concat(baseRelativeUri, "menu") : "".concat(baseRelativeUri, "/menu");
    var baseHref = normalizeUrlForOrderIntent(baseRelativeUri);
    var menuHref = normalizeUrlForOrderIntent(menuRelativeUri);
    return currentHref === baseHref || currentHref === menuHref;
};
var getErrorStatus = function (error) {
    var _a;
    if (!error || typeof error !== "object") {
        return null;
    }
    var status = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
    return typeof status === "number" ? status : null;
};
var getServiceTypeErrorMessage = function (error) {
    var _a, _b;
    if (!error || typeof error !== "object") {
        return "We couldn't update your service type. Please refresh the page try again.";
    }
    var response = error.response;
    var data = response === null || response === void 0 ? void 0 : response.data;
    var friendlyName = String(((_a = data === null || data === void 0 ? void 0 : data.friendly) === null || _a === void 0 ? void 0 : _a.name) || (data === null || data === void 0 ? void 0 : data.name) || "").trim();
    var friendlyDescription = String(((_b = data === null || data === void 0 ? void 0 : data.friendly) === null || _b === void 0 ? void 0 : _b.description) || (data === null || data === void 0 ? void 0 : data.description) || "").trim();
    if (friendlyName && friendlyDescription) {
        return "".concat(friendlyName, " ").concat(friendlyDescription).trim();
    }
    if (friendlyDescription) {
        return friendlyDescription;
    }
    if (friendlyName) {
        return friendlyName;
    }
    var message = String((data === null || data === void 0 ? void 0 : data.message) || "").trim();
    if (!message) {
        return "We couldn't update your service type. Please refresh the page try again.";
    }
    if (message === "You must specify an address!" || message === "You must specify an city!" || message === "You must specify an zip!") {
        return "Please enter a complete delivery address to continue.";
    }
    if (message === "Sorry, this order does not meet the minimum delivery amount.") {
        return "Your cart is below the delivery minimum. Add a little more or switch to pickup.";
    }
    return message;
};
var getFutureOrderDays = function () {
    var _a, _b, _c, _d;
    var sessionValue = (_c = (_b = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.future_order_days) !== null && _c !== void 0 ? _c : (_d = window.session) === null || _d === void 0 ? void 0 : _d.future_order_days;
    if (typeof sessionValue === "number" && Number.isFinite(sessionValue)) {
        return sessionValue;
    }
    if (typeof sessionValue === "string" && sessionValue.trim().length > 0) {
        var parsed = Number(sessionValue);
        if (Number.isFinite(parsed)) {
            return parsed;
        }
    }
    return 0;
};
var normalizeDatetimeForUi = function (datetimeValue) {
    var _a, _b;
    var normalizedValue = String(datetimeValue || "").trim();
    if (!normalizedValue) {
        return "";
    }
    var standardFormatMatch = normalizedValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})\s(\d{1,2}):(\d{2})\s(AM|PM)$/i);
    if (standardFormatMatch) {
        var month = standardFormatMatch[1], day = standardFormatMatch[2], year = standardFormatMatch[3], hour = standardFormatMatch[4], minute = standardFormatMatch[5], meridiem = standardFormatMatch[6];
        return "".concat(month.padStart(2, "0"), "/").concat(day.padStart(2, "0"), "/").concat(year, " ").concat(hour.padStart(2, "0"), ":").concat(minute, " ").concat(meridiem.toUpperCase());
    }
    var dbFormatMatch = normalizedValue.match(/^(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2})(?::\d{2})?$/);
    if (dbFormatMatch) {
        var year = dbFormatMatch[1], month = dbFormatMatch[2], day = dbFormatMatch[3], hourText = dbFormatMatch[4], minute = dbFormatMatch[5];
        var hour24 = Number(hourText);
        var meridiem = hour24 >= 12 ? "PM" : "AM";
        var hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
        return "".concat(month, "/").concat(day, "/").concat(year, " ").concat(String(hour12).padStart(2, "0"), ":").concat(minute, " ").concat(meridiem);
    }
    var parsedDate = new Date(normalizedValue);
    if (!Number.isNaN(parsedDate.getTime())) {
        var storeTimezone = String(((_b = (_a = window.session) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.timezone) || "UTC");
        var formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: storeTimezone,
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
        var formatted = formatter.format(parsedDate);
        var _c = formatted.split(", "), _d = _c[0], datePart = _d === void 0 ? "" : _d, _e = _c[1], timePart = _e === void 0 ? "" : _e;
        if (datePart && timePart) {
            return "".concat(datePart, " ").concat(timePart);
        }
    }
    return normalizedValue;
};
var formatFutureOrderLabel = function (futureOrderDatetime) {
    var normalizedDatetime = normalizeDatetimeForUi(String(futureOrderDatetime || ""));
    if (!normalizedDatetime) {
        return "Future order";
    }
    return "Future \u2022 ".concat(normalizedDatetime);
};
var getSchedulePromptLabel = function (futureOrderDatetime, isFutureOnlyFlow) {
    if (isFutureOnlyFlow && !futureOrderDatetime) {
        return "Schedule a time";
    }
    return formatFutureOrderLabel(futureOrderDatetime);
};
export var OrderIntentNavbar = function () {
    var _a = React.useState(true), storeStatusIsVisible = _a[0], setStoreStatusIsVisible = _a[1];
    var serviceTypes = useServiceTypes().serviceTypes;
    var _b = useAuth(), history = _b.history, user = _b.user, createAddress = _b.createAddress;
    var _c = useCart(), cart = _c.cart, getCart = _c.getCart;
    var _d = useUI(), orderTimeFlyoutIsOpen = _d.orderTimeFlyoutIsOpen, setOrderTimeFlyoutIsOpen = _d.setOrderTimeFlyoutIsOpen, orderAddressDetailsFlyoutIsOpen = _d.orderAddressDetailsFlyoutIsOpen, setOrderAddressDetailsFlyoutIsOpen = _d.setOrderAddressDetailsFlyoutIsOpen, showToast = _d.showToast;
    var _e = useOrderIntent(), serviceTypeId = _e.serviceTypeId, setServiceType = _e.setServiceType, setCartServiceType = _e.setCartServiceType, currentAddress = _e.currentAddress, setCurrentAddress = _e.setCurrentAddress, orderTiming = _e.orderTiming, futureOrderDatetime = _e.futureOrderDatetime, locationCount = _e.locationCount, todayStoreHours = _e.todayStoreHours, setAsapOrder = _e.setAsapOrder, setFutureOrder = _e.setFutureOrder, futureDates = _e.futureDates, selectedFutureDate = _e.selectedFutureDate, futureDateHours = _e.futureDateHours, futureAvailabilityMessage = _e.futureAvailabilityMessage, futureAvailabilityLoading = _e.futureAvailabilityLoading, setSelectedFutureDate = _e.setSelectedFutureDate, validateFutureOrderDatetime = _e.validateFutureOrderDatetime, serviceTypeEligibility = _e.serviceTypeEligibility;
    if (!isOrderIntentNavbarRoute()) {
        return null;
    }
    var store = getSessionStore();
    var storeStatus = getSessionStoreStatus();
    var _f = getStoreAddressLines(store), name = _f.name, lineOne = _f.lineOne, lineTwo = _f.lineTwo;
    var setCartServiceTypeAndRefresh = React.useCallback(function (nextServiceType, address) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setCartServiceType(nextServiceType, address)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getCart()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [getCart, setCartServiceType]);
    var setAsapOrderAndRefresh = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setAsapOrder()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getCart()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [getCart, setAsapOrder]);
    var setFutureOrderAndRefresh = React.useCallback(function (datetime) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setFutureOrder(datetime);
                    return [4 /*yield*/, getCart()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [getCart, setFutureOrder]);
    var setSelectedFutureDateAndRefresh = React.useCallback(function (date, shouldClearExistingDeferred) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, setSelectedFutureDate(date, shouldClearExistingDeferred)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getCart()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [getCart, setSelectedFutureDate]);
    var showSessionRecoveryToast = React.useCallback(function () {
        showToast("Your session expired and could not be recovered. Please refresh the page to continue ordering.", "warning", true, {
            label: "Refresh",
            onClick: function () { return window.location.reload(); },
        });
    }, [showToast]);
    var cartServiceTypeId = typeof (cart === null || cart === void 0 ? void 0 : cart.service_type_id) === "number" ? cart.service_type_id : null;
    var resolvedServiceTypeId = serviceTypeId !== null && serviceTypeId !== void 0 ? serviceTypeId : cartServiceTypeId;
    var selectedServiceTypeValue = resolvedServiceTypeId === null ? null : String(resolvedServiceTypeId);
    var serviceTypeOptions = serviceTypes.map(function (serviceType) {
        var serviceTypeName = String(serviceType.name || "Service");
        return {
            value: String(serviceType.id),
            label: serviceTypeName,
            icon: getServiceTypeIcon(serviceTypeName),
            ariaLabel: serviceTypeName,
        };
    });
    var hasServiceTypeSelected = resolvedServiceTypeId !== null;
    var orderTimeDisabledMessage = hasServiceTypeSelected ? null : "Choose a service type before selecting an order time.";
    var selectedServiceType = serviceTypes.find(function (candidate) { return String(candidate.id) === selectedServiceTypeValue; }) || null;
    var deliveryServiceType = serviceTypes.find(function (candidate) { return isDeliveryServiceType(candidate); }) || null;
    var deferredDatetimeFromCart = typeof (cart === null || cart === void 0 ? void 0 : cart.deferred_datetime) === "string" && cart.deferred_datetime.trim().length > 0
        ? cart.deferred_datetime
        : null;
    var hasDeferredDatetimeFromCart = Boolean(deferredDatetimeFromCart);
    var effectiveOrderTiming = !serviceTypeEligibility.canAsap && serviceTypeEligibility.canFuture
        ? "future"
        : (orderTiming === "future" || hasDeferredDatetimeFromCart) ? "future" : "asap";
    var effectiveFutureOrderDatetime = effectiveOrderTiming === "future"
        ? (deferredDatetimeFromCart || futureOrderDatetime)
        : null;
    var isFutureOnlyFlow = !serviceTypeEligibility.canAsap && serviceTypeEligibility.canFuture;
    var timingLabel = orderTimeDisabledMessage || (effectiveOrderTiming === "future"
        ? getSchedulePromptLabel(effectiveFutureOrderDatetime, isFutureOnlyFlow)
        : getAsapTimingLabel(selectedServiceType === null || selectedServiceType === void 0 ? void 0 : selectedServiceType.current_time));
    var hasFutureOrdering = serviceTypeEligibility.canFuture && getFutureOrderDays() >= 1;
    var storeAddressLine = [lineOne, lineTwo].filter(Boolean).join(", ");
    var selectedDeliveryServiceTypeRef = React.useRef(null);
    var addressAppliedFromFlyoutRef = React.useRef(false);
    var previousOrderAddresses = React.useMemo(function () {
        var addresses = Array.isArray(history === null || history === void 0 ? void 0 : history.addresses) ? history.addresses : [];
        return addresses.map(function (address) { return (__assign(__assign({}, address), { display_name: typeof address.display_name === "string" ? address.display_name : undefined })); });
    }, [history === null || history === void 0 ? void 0 : history.addresses]);
    var handleAddressFlyOutOpenChange = function (open) {
        setOrderAddressDetailsFlyoutIsOpen(open);
        if (open) {
            addressAppliedFromFlyoutRef.current = false;
            return;
        }
        if (addressAppliedFromFlyoutRef.current) {
            addressAppliedFromFlyoutRef.current = false;
            return;
        }
        var hasAddress = Boolean(String((currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.address) || "").trim());
        if (!hasAddress) {
            setServiceType(null);
        }
    };
    var handleAddressApply = function (address) { return __awaiter(void 0, void 0, void 0, function () {
        var normalizedAddress, normalizedAddress2, normalizedCity, normalizedState, normalizedZip, serviceTypeToApply, resolvedAddress, historyAddresses, matchingHistoryAddress, createdAddress, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!address) {
                        return [2 /*return*/];
                    }
                    normalizedAddress = String(address.address || "").trim().toLowerCase();
                    normalizedAddress2 = String(address.address2 || "").trim().toLowerCase();
                    normalizedCity = String(address.city || "").trim().toLowerCase();
                    normalizedState = String(address.state || "").trim().toLowerCase();
                    normalizedZip = String(address.zip || "").trim().toLowerCase();
                    if (!normalizedAddress || !normalizedCity || !normalizedState || !normalizedZip) {
                        showToast("Please enter a complete delivery address to continue.", "error");
                        return [2 /*return*/];
                    }
                    serviceTypeToApply = selectedDeliveryServiceTypeRef.current || deliveryServiceType;
                    if (!serviceTypeToApply) {
                        showToast("Delivery service type is unavailable right now.", "error");
                        throw new Error("Delivery service type is unavailable.");
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    resolvedAddress = address;
                    if (!(!address.id && (user === null || user === void 0 ? void 0 : user.id))) return [3 /*break*/, 4];
                    historyAddresses = Array.isArray(history === null || history === void 0 ? void 0 : history.addresses) ? history.addresses : [];
                    matchingHistoryAddress = historyAddresses.find(function (candidate) {
                        return String(candidate.address || "").trim().toLowerCase() === normalizedAddress
                            && String(candidate.address2 || "").trim().toLowerCase() === normalizedAddress2
                            && String(candidate.city || "").trim().toLowerCase() === normalizedCity
                            && String(candidate.state || "").trim().toLowerCase() === normalizedState
                            && String(candidate.zip || "").trim().toLowerCase() === normalizedZip;
                    });
                    if (!matchingHistoryAddress) return [3 /*break*/, 2];
                    resolvedAddress = matchingHistoryAddress;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, createAddress({
                        address: String(address.address || "").trim(),
                        address2: String(address.address2 || "").trim(),
                        city: String(address.city || "").trim(),
                        state: String(address.state || "").trim(),
                        zip: String(address.zip || "").trim(),
                        userId: user.id,
                    })];
                case 3:
                    createdAddress = _a.sent();
                    if (createdAddress) {
                        resolvedAddress = createdAddress;
                    }
                    _a.label = 4;
                case 4:
                    setCurrentAddress(resolvedAddress);
                    setServiceType(serviceTypeToApply.id);
                    return [4 /*yield*/, setCartServiceTypeAndRefresh(serviceTypeToApply, resolvedAddress)];
                case 5:
                    _a.sent();
                    addressAppliedFromFlyoutRef.current = true;
                    selectedDeliveryServiceTypeRef.current = null;
                    return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    setServiceType(null);
                    if (getErrorStatus(error_1) === 419) {
                        showSessionRecoveryToast();
                        throw error_1;
                    }
                    showToast(getServiceTypeErrorMessage(error_1), "error");
                    throw error_1;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement("section", { className: "order-intent-navbar", "aria-label": "Order intent controls" },
            React.createElement("div", { className: "order-intent-navbar-inner" },
                React.createElement("div", { className: "order-intent-navbar-store-panel" },
                    React.createElement("p", { className: "order-intent-navbar-store-name", title: name }, name),
                    storeAddressLine ? React.createElement("p", { className: "order-intent-navbar-store-line", title: storeAddressLine }, storeAddressLine) : null,
                    todayStoreHours ? (React.createElement("p", { className: "order-intent-navbar-store-hours", title: "Today's hours: ".concat(todayStoreHours) },
                        "Today's hours: ",
                        todayStoreHours)) : null,
                    locationCount > 1 ? (React.createElement(RadixButton, { type: "button", className: "order-intent-navbar-link-button", onClick: function () { return window.location.assign("/locator"); } }, "Change location")) : null),
                React.createElement("div", { className: "order-intent-navbar-controls-panel" },
                    React.createElement(RadixToggleGroup, { options: serviceTypeOptions, value: selectedServiceTypeValue, onValueChange: function (value) {
                            var parsed = Number(value);
                            if (Number.isNaN(parsed)) {
                                return;
                            }
                            var selected = serviceTypes.find(function (candidate) { return candidate.id === parsed; }) || null;
                            if (isDeliveryServiceType(selected)) {
                                selectedDeliveryServiceTypeRef.current = selected;
                                setServiceType(parsed);
                                setOrderAddressDetailsFlyoutIsOpen(true);
                                return;
                            }
                            selectedDeliveryServiceTypeRef.current = null;
                            setCartServiceTypeAndRefresh(parsed, null).catch(function (error) {
                                if (getErrorStatus(error) === 419) {
                                    showSessionRecoveryToast();
                                    return;
                                }
                                showToast(getServiceTypeErrorMessage(error), "error");
                            });
                        }, ariaLabel: "Available service types", className: "order-intent-navbar-toggle-row order-intent-navbar-service-toggle", activeOptionClassName: "order-intent-navbar-service-toggle-item--active" }),
                    React.createElement(RadixButton, { type: "button", className: "order-intent-navbar-info-row", onClick: function () { return setOrderTimeFlyoutIsOpen(true); }, disabled: !hasServiceTypeSelected },
                        React.createElement("span", { className: "order-intent-navbar-info-leading-icon" },
                            React.createElement(ClockIcon, null)),
                        React.createElement("span", { className: "order-intent-navbar-info-text" }, timingLabel),
                        React.createElement("span", { className: "order-intent-navbar-info-trailing-icon" },
                            React.createElement(ChevronRightIcon, null)))),
                storeStatus && storeStatusIsVisible ? (React.createElement("div", { className: "order-intent-navbar-status", role: "status" },
                    React.createElement("span", { className: "order-intent-navbar-status-icon", "aria-hidden": "true" },
                        React.createElement(InfoCircledIcon, null)),
                    React.createElement("p", { className: "order-intent-navbar-status-message" }, storeStatus.message),
                    React.createElement("button", { type: "button", className: "order-intent-navbar-status-dismiss", "aria-label": "Dismiss store status", onClick: function () { return setStoreStatusIsVisible(false); } },
                        React.createElement(Cross2Icon, null)))) : null)),
        React.createElement(OrderTimeSelectionFlyOut, { open: orderTimeFlyoutIsOpen, onOpenChange: setOrderTimeFlyoutIsOpen, orderTiming: effectiveOrderTiming, futureOrderDatetime: effectiveFutureOrderDatetime, onSetAsapOrder: setAsapOrderAndRefresh, onSetFutureOrder: setFutureOrderAndRefresh, hasFutureOrdering: hasFutureOrdering, futureDates: futureDates, selectedFutureDate: selectedFutureDate, futureDateHours: futureDateHours, futureAvailabilityMessage: futureAvailabilityMessage, futureAvailabilityLoading: futureAvailabilityLoading, onSelectFutureDate: setSelectedFutureDateAndRefresh, onValidateFutureDatetime: validateFutureOrderDatetime, canSelectAsap: hasServiceTypeSelected && serviceTypeEligibility.canAsap, canSelectFuture: hasServiceTypeSelected && serviceTypeEligibility.canFuture, disabledMessage: orderTimeDisabledMessage, onSelectionSuccess: function (timing) {
                if (timing === "future") {
                    showToast("Future order time applied.", "success");
                    return;
                }
                showToast("Order time set to ASAP.", "success");
            } }),
        React.createElement(OrderAddressDetailsFlyOut, { open: orderAddressDetailsFlyoutIsOpen, onOpenChange: handleAddressFlyOutOpenChange, address: currentAddress, onApplyAddress: handleAddressApply, previousAddresses: previousOrderAddresses })));
};
